// Name of the linked price table, empty when none is linked or the table no longer exists
export function getPriceTableName(priceTables, priceTableId) {
    if (!priceTableId) return ''

    return (priceTables || []).find((priceTable) => priceTable.id === priceTableId)?.name || ''
}
